import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { HiCheckBadge } from 'react-icons/hi2';
import certifications from '../Constants/Certifications';

const CertificationCard = ({ cert, index }) => {
  const [imageFailed, setImageFailed] = useState(false);

  return (
    <motion.article
      className="cert-card"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: index * 0.08, ease: 'easeOut' }}
      viewport={{ once: true, amount: 0.25 }}
    >
      <div className="cert-badge" aria-hidden="true">
        {imageFailed ? (
          <HiCheckBadge size={36} />
        ) : (
          <img alt={`${cert.title} badge`} src={cert.badgeSrc} onError={() => setImageFailed(true)} />
        )}
      </div>
      <p className="cert-track">{cert.track}</p>
      <h3>{cert.title}</h3>
      <p className="cert-credential">{cert.credential}</p>
      <div className="cert-meta">
        <span>Issuer: {cert.issuer}</span>
        <span>Year: {cert.year}</span>
      </div>
    </motion.article>
  );
};

const Certifications = () => {
  return (
    <section id="Certifications" className="section-wrap">
      <div className="section-header">
        <p className="eyebrow">Certifications</p>
        <h2 className="section-title">Oracle Credentials</h2>
      </div>

      <div className="cert-grid">
        {certifications.map((cert, index) => (
          <CertificationCard key={cert.id} cert={cert} index={index} />
        ))}
      </div>
    </section>
  );
};

export default Certifications;
